// extracted by mini-css-extract-plugin
export default {"MainCont":"Assembly_MainCont__TKRmK","LeftCont":"Assembly_LeftCont__XZFYt","RightCont":"Assembly_RightCont__mYIE-"};